import { mentionTypes, socketTypes } from '../actions'

const initialState = {
  data: []
}

const sample = (state = initialState, action) => {
  switch (action.type) {
    case 'mentions/CHECK_MENTIONS_SUCCESS':
      return {
        ...state,
        data: action.payload.data
      }
    case mentionTypes.CLEAR_MENTIONS:
      return initialState
    case socketTypes.SET_ACTIVESESSION:
      return initialState
    default:
      return state
  }
}

export default sample



// WEBPACK FOOTER //
// ./src/reducers/mentions.js